module.exports = __webpack_public_path__ + "assets/img/StructureBAPC.329228e0.png";